import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent, defineAsyncComponent, ref, computed, watch, provide, onMounted } from 'vue';
import axios from "axios";
import { api } from "@/api/api";
import { useStore } from 'vuex';
import router from '@/router';
export default {
  name: 'member_welfare',
  setup() {
    const get_data = ref({});
    const pic = ref("");
    const store = useStore(); // 该方法用于返回store 实例
    const Client = store.state.Client;
    const show = () => {
      store.commit('serviceShow', true);
    };
    // 用户信息
    const user_info = ref(null);
    try {
      const userData = localStorage.getItem('userData');
      if (userData) {
        user_info.value = JSON.parse(userData);
      }
    } catch (error) {
      console.error('Error parsing user data:', error);
    }

    // 如果没有用户信息，返回错误或重定向
    if (!user_info.value || !user_info.value.id) {
      console.error('User data not found');
      router.push('/login_m/2'); // 或者其他适当的处理
      return {
        get_data: ref({}),
        pic: ref(''),
        push: () => {},
        show: () => {},
        fh: () => {},
        jindu: ref(0)
      };
    }

    // console.log(route.params);
    let url = api.baseUrl + api.activity_hy + '?id=2&userId=' + user_info.value.id;
    axios({
      url,
      method: "get"
    }).then(res => {
      let {
        data
      } = res;
      console.log(data);
      let tmpList = [];

      // 安全检查 API 响应
      if (data && data.data && data.data.materials && data.data.materials.length > 0) {
        pic.value = data.data.materials[0].url || '';
        for (let index in data.data.materials) {
          // console.log(data.data.materials[index].type.indexOf("video")==0);
          if (data.data.materials[index].type && data.data.materials[index].type.indexOf("video") == 0) {
            tmpList.push(data.data.materials[index]);
          }
        }
        console.log(tmpList);
        // data.data.materials = tmpList;
        get_data.value = data.data;
        // get_data.value.materials = tmpList;

        let count = tmpList.length;
        let completeCount = 0;
        for (let index in tmpList) {
          if (tmpList[index].statusStr == "已完成") {
            completeCount += 1;
          }
        }
        if (completeCount != 0) {
          // console.log(/completeCount);
          get_data.value.status = parseFloat(completeCount / count * 100).toFixed(0);
        } else {
          get_data.value.status = 0;
        }
      } else {
        // 如果没有数据，设置默认值
        get_data.value = {
          benefitName: '',
          benefitExplain: '',
          status: 0,
          materials: []
        };
      }
    }).catch(error => {
      console.error('API request failed:', error);
      // 设置默认值以防止错误
      get_data.value = {
        benefitName: '',
        benefitExplain: '',
        status: 0,
        materials: []
      };
    });

    // 计算训练进度
    const jindu = computed(() => {
      let jindu_num = 0;
      if (get_data.value.materials) {
        get_data.value.materials.map(item => {
          if (item.statusStr == '已完成') {
            jindu_num++;
          }
        });
        return parseInt(jindu_num / get_data.value.materials.length * 100);
      } else {
        return jindu_num;
      }
    });
    const push = item => {
      if (item.lock) {
        show();
        return;
      }
      // if (item.statusStr == '已完成') {
      //     // console.log(item);
      //     window.open(item.url)
      //     return
      // }
      router.push({
        path: '/member_upload_push_m',
        query: {
          ...item
        }
      });
    };
    const fh = () => {
      router.go(-1);
    };
    return {
      get_data,
      Client,
      push,
      pic,
      show,
      fh,
      jindu
    };
  }
};